import { Directive, ElementRef } from '@angular/core';

import { ThumbnailRefreshService } from '@core/services/thumbnail-refresh.service';

const BROKEN_IMAGE_ICON = 'assets/icons/icon-brokenimage.svg';

@Directive({
  selector: '[appImageError]',
  standalone: true,
})
export class ImageErrorDirective {
  constructor(el: ElementRef, private readonly thumbnailRefreshService: ThumbnailRefreshService) {
    el.nativeElement.onerror = event => {
      if (window.navigator.onLine && !event.target.src.includes(BROKEN_IMAGE_ICON)) {
        const failedSrc = event.target.src;
        event.target.src = BROKEN_IMAGE_ICON;
        this.thumbnailRefreshService.notifyThumbnailFailed(failedSrc);
      }
    };
  }
}
